// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".market-row div[data-v-b669e04a]{font-size:13px}.cancel[data-v-b669e04a],.text-secondary[data-v-b669e04a]{color:var(--color-secondary)!important}.text-primary[data-v-b669e04a]{color:var(--color-primary)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
